import { isString, assign } from 'lodash';

export default (selector, options = {}) => {
  let $el = selector;

  if (!$el) {
    throw new Error('Selector is empty');
  }

  if (isString($el)) {
    $el = document.querySelector($el);
  }

  if (!($el instanceof HTMLElement)) {
    return;
  }

  const defaultOptions = {};
  const opts = assign(defaultOptions, options);

  return require.ensure([], require => {
    const Inputmask = require('inputmask');

    return new Inputmask(opts).mask($el);
  });
};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/Global/AsyncModules/inputmask.js